<script setup lang="ts">
import {ICellRendererParams} from "ag-grid-community";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import {computed} from "vue";

const props = defineProps<{ params: ICellRendererParams }>();
const metaData: namaTypes.BasicFieldMetaData = props.params["metaData"];
const displayValue = computed(() => Translator.translate(props.params.value, metaData.enumTypeName) ?? '');
const highlightedHtml = computed(() => AGGridUtils.getFindHighlightedHtml(props.params.api, props.params.node, props.params.column, displayValue.value));

</script>

<template>
  <div class="tw-flex tw-items-center tw-justify-between">
    <span v-if="highlightedHtml" v-html="highlightedHtml" class="tw-overflow-hidden"/>
    <span v-else v-text="displayValue" class="tw-overflow-hidden"/>
    <NamaIcon :enumTypeName="metaData.enumTypeName" :allowed-value="params.value"/>
  </div>
</template>
